export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form-comment.vue?vue&type=template&id=09eed474&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/form-comment/form-comment.vue?vue&type=template&id=09eed474&
// module id = 1232
// module chunks = 0